import i18n from 'live/services/i18n'

import { PT_BR } from './pt_br'
import { EN_US } from './en_us'

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'pt_br'
const localeFiles = { pt_br: PT_BR, en_us: EN_US }

export function addi18n(): void {
    i18n.add(localeFiles[locale])
}
